module.exports = __webpack_public_path__ + "img/paul.1c2fb324.jpg";